import { FeedRecommendationSubscriptionDocument, FeedRecommendationSubscriptionSubscription, FeedRecommendationSubscriptionSubscriptionVariables } from '@ui/mutations/feedRecommendationSubscription';

import { toast } from '@ui/components/molecules/Toaster';
import useCustomRouter from '@ui/hooks/useCustomRouter';
import { routePath } from '@ui/constants/routes';
import Button from '@mildang/design-system-legacy/esm/components/molecules/Button';
import { gql } from '@apollo/client';
import { NewFeedListenerMeDocument, NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables } from './NewFeedListener.generated';
import { isProject } from '@shared/constants/projectTarget';
import { useSubscription, useQuery } from '@apollo/client';


function NewFeedListener() {
  const router = useCustomRouter();
  const { data } = useQuery<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>(NewFeedListenerMeDocument);
  const studentId = data?.me?.student?.id;

  useSubscription<FeedRecommendationSubscriptionSubscription, FeedRecommendationSubscriptionSubscriptionVariables>(FeedRecommendationSubscriptionDocument, {
    variables: {
      studentId: studentId ?? '',
    },
    skip: !studentId || isProject('mildang'),
    onSubscriptionData({ subscriptionData }) {
      if (!subscriptionData.data?.feedRecommendationSubscription) return;
      const { feedTitle, studyActivityInstanceId, studyModuleInstanceId, studyUnitInstanceId } =
        subscriptionData.data.feedRecommendationSubscription;

      toast.success(`"${feedTitle} - 추천 학습" 피드를 학습하러 이동해볼까요? `, {
        position: 'bottom-center',
        title: '새로운 피드가 도착했어요 🎁',
        duration: 1000000000,
        infinite: true,
        isClosable: true,
        action: (
          <Button
            whiteSpace="nowrap"
            variant="text"
            color="secondary"
            onClick={() => {
              router.push(
                routePath.href('/study-module/[studyModuleInstanceId]/[unitId]/[activityId]/result', {
                  studyModuleInstanceId: studyModuleInstanceId,
                  unitId: studyUnitInstanceId,
                  activityId: studyActivityInstanceId,
                  pageType: 'learn',
                }),
              );
              toast.dismiss();
            }}
          >
            바로가기
          </Button>
        ),
      });
    },
  });

  return null;
}

export default NewFeedListener;

gql`
  query NewFeedListenerMe {
    me {
      id
      student {
        id
      }
    }
  }
`;
